import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type ScrollingSection } from '../../../WebsiteBuilder.types'

const websiteBuilderQueue = useBuilder('websiteBuilder')

const ScrollingCommands = {
  updateBlock: websiteBuilderQueue.createBlockCommand<ScrollingSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { ScrollingCommands }
